<template>
  <div
    v-loading="loading"
    @click="handtipshow"
  >
    <div class="opallbox">
      <div class="chawepalite">
        <div class="optiontext">选择平台</div>
        <el-select v-model="platformvalue" placeholder="请选择" @change="plateall">
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </div>
      <div class="optionbox">
        <div class="optiontext">标题</div>
        <el-input v-model.trim="bigtitle" placeholder="请输入大标题" style="margin-right:10px" />
      </div>
    </div>
    <div class="editbox">
      <div class="centerbox">
        <!-- <el-input v-model.trim="arr[0].title" class="centerinput" placeholder="标题" /> -->

        <div style="border: 1px solid #ccc; margin:10px 0px">
          <!-- <Editor-wang ref="editorwangfour" v-model.trim="arr[0].content" /> -->
          <el-input
            v-model="arr[0].content"
            type="textarea"
            :rows="8"
            placeholder="请输入内容"
            @blur="handleInputBlur"
          />
          <el-link type="primary" class="link_url" @click="linkclick">超链接</el-link>

        </div>

        <el-button type="primary" class="btne" @click="go">提交</el-button>
      </div>

    </div>
    <!-- 超链接弹窗 -->
    <el-dialog
      title="超链接"
      :visible.sync="linkdialogVisible"

      width="30%"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <Linkdialog ref="linkdialog" @linkbtn="linkbtn" />
    </el-dialog>
  </div>

</template>

<script>

import { qiniuToken } from '@/api/qiniuToken.js'
import { strategyPlatform, articleDetail } from '@/api/sourceMaterial.js'
import { addTextVoice, updateTextVoice } from '@/api/templatelist.js'
// import EditorWang from './components/AboutView.vue'
import Linkdialog from './components/Linkdialog.vue'
export default {

  components: {
    // EditorWang
    Linkdialog
  },
  data() {
    return {
      loading: false,
      disabled: false,
      baseUrl: './',
      language: 'zh_CN',
      skin: 'oxide',
      bigtitle: '',
      arr: [
        {
          // title: '文本', // 标题
          content: '' // 富文本框的内容
        }
      ],
      imgarr: [{
        img: 'https://qie-online-sale-qiniu.wsandos.com/meinv.jpg'

      }, {
        img: require('@/assets/larke/larke.png')
      }],
      options: [],

      platformvalue: 99, // 选择平台
      officialaccountname: '', // 选择公众号名称
      sendata: '', // 发送日期

      indexinput: null, // 取出来的索引值

      token: null, // 七牛云token

      editor: null,
      html: '<p>hello&nbsp;world</p>',
      toolbarConfig: {
        // toolbarKeys: [ /* 显示哪些菜单，如何排序、分组 */ ],
        excludeKeys: ['group-image', 'group-video']
      },
      editorConfig: {
        placeholder: '请输入内容...',
        // autoFocus: false,
        pasteFilterStyle: false,
        pasteIgnoreImg: false,
        // 所有的菜单配置，都要在 MENU_CONF 属性下
        MENU_CONF: {
          // 配置上传图片
          uploadImage: {
            customUpload: this.update
          }
        }
      },
      radiosize: 1,
      edittype: null, // false编辑 true新增
      edittyper: null,
      editid: null, // 编辑时的id
      choicedialogVisible: false,
      bookctyactivitiesVisible: false,
      redbao: false,
      sclink: false,
      dialogVisibler: false,
      chapterdialogVisibler: false,
      palarr: [],
      dialogVisible1: false,
      iframeURL: '',
      linkallarr: [],
      choserauthtype: null,
      accountpusharr: [],
      bottomarr: [],
      whichIndex: -1,
      type: 2,
      //  超链接弹窗
      linkdialogVisible: false
    }
  },
  created(query) {
    this.getPlatform()
    console.log('query', this.$route.query)

    console.log('edittype', this.edittype)
    this.getQiniuToken()
    this.active = this.arr[0].id
    this.indexinput = 0
    this.getinforlist()
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁 editor ，重要！！！
  },
  methods: {
    // 获取详情
    async getinforlist() {
      this.editid = this.$route.query.id
      console.log('this.editid----', this.editid)
      if (this.editid === null || this.editid === undefined) {
        return
      }
      const data = await articleDetail({
        id: this.editid
      })
      console.log('获取详情-----', data)

      this.arr[0].content = data.data.articles[0].content
      // this.arr[0].title = data.data.articles[0].title
      this.bigtitle = data.data.title
      this.platformvalue = data.data.platform_id
      // this.active = this.arr[0].id
      console.log('详情', data)
      this.loading = false
    },

    plateall(val) {
      console.log('val', val)
      // 清空添加链接活动数组
      this.linkallarr = []
      // eslint-disable-next-line eqeqeq
      if (val == 99) {
        console.log('通用')
      } else {
        console.log('常规')
        // this.getlinktypesalllist()
      }
    },

    // 获取平台
    async getPlatform() {
      const data = await strategyPlatform()
      this.options = data.data.list
      console.log('获取平台', this.options)
    },
    handtipshow() {
      if (document.querySelector('.ciclebox')) { // 先判断下，不然会报错
        this.$nextTick(() => {
          this.arr.forEach(item => {
            item.showtips = false
          })
        })
      }
    },

    // 提交
    async go() {
      this.arr[0].content = this.arr[0].content.trim()
      if (this.platformvalue === null) {
        this.$message.error('请选择平台')
        return
      }
      if (this.bigtitle === '') {
        this.$message.error('请输入列表标题')
        return
      }
      // if (this.arr[0].title === '') {
      //   this.$message.error('请输入标题')
      //   return
      // }
      console.log('this.arr[0].content', this.arr[0].content)
      if (this.arr[0].content === '') {
        this.$message.error('请输入文本内容')
        return
      }

      if (this.editid === null || this.editid === undefined) {
        const data = await addTextVoice({
          title: this.bigtitle,
          type: this.type,
          platform_id: this.platformvalue,
          articles: this.arr
        })
        if (data.code === 200) {
          this.$message({
            type: 'success',
            message: '新增文本模板成功!'
          })
          this.$router.push({ path: '/offiaccountemlist/index' })
        }
      } else {
        // updateTextVoice
        const data = await updateTextVoice({
          title: this.bigtitle,
          type: this.type,
          platform_id: this.platformvalue,
          articles: this.arr,
          id: this.editid
        })
        if (data.code === 200) {
          this.$message({
            type: 'success',
            message: '文本模版修改成功!'
          })
          this.$router.push({ path: '/offiaccountemlist/index' })
        }
      }
      console.log('this.arrs', this.arr)
    },

    // 获取七牛token
    async getQiniuToken() {
      const data = await qiniuToken()
      this.token = data.data.upToken
    },

    beforehandleCommand() {
      // eslint-disable-next-line eqeqeq
      if (this.platformvalue == 99) {
        if (this.arr[this.indexinput].item_platform_id === '') {
          this.$message.error('请选择子平台')
          return
        }
      } else {
        if (this.platformvalue === null) {
          this.$message.error('请选择平台')
          return
        }
      }
    },

    clickicongon(val) {
      this.dialogVisible = false
      this.$refs.editorwangfour.send(val, 1)
    },
    callback(item, type) {
      this.choicedialogVisible = false
      console.log(item, type)
      if (type === 1) {
        this.$refs.editorwangfour.send(item, 2)
      } else if (type === 2) {
        this.$refs.editorwangfour.send(item, 3)
      } else {
        this.$refs.editorwangfour.send(item, 4)
      }
    },
    callbackcontent(val) {
      this.dialogVisible1 = false
      this.$refs.editorwangfour.send(val, 5)
    },
    // 获取光标所在位置的index
    handleInputBlur(e) {
      this.blurIndex = e.srcElement.selectionStart
    },
    linkclick() {
      if (this.textpalateid === '') {
        this.$message.error('请选择平台')
        return
      }
      this.linkdialogVisible = true
      this.$nextTick(() => {
        this.$refs.linkdialog.linksend(this.textpalateid)
      })
    },
    // 选择超链接回调
    linkbtn(linkobj) {
      this.arr[0].content = this.arr[0].content.slice(0, this.blurIndex) + `<a href="${linkobj.linkwritten}">${linkobj.written}</a>` + this.arr[0].content.slice(this.blurIndex)
      this.linkdialogVisible = false
    }
  }
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped>
.opallbox{
  padding: 20px 20px 0px 20px;
  display: flex;
  flex-wrap: wrap;
}

.optionbox{
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 15px;
}
.optiontext{
  margin-right: 10px;
  font-size: 14px;
  flex-shrink: 0;
}
.editbox{
  /* padding: 0 20px 0px 20px; */
  display: flex;
}
.leftbox{
  width: 403px;
}
.addbox{
  width: 403px;
  height: 48px;
  border: 1px solid #f3f3f3;
  text-align: center;
  line-height: 48px;
  position: relative;
}
.updatabox{
  height: 158px;
  text-align: center;
  line-height: 158px;
  border: 1px solid #f3f3f3;
  position: relative;
}
.updatabox1{
    position: relative;
    height: 72px;
    border: 1px solid #f3f3f3;
    padding: 0 27px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.srvbox{
  width: 50px;
  height: 40px;
}
.spanbox{
  position: absolute;
  left: 18px;
  z-index: 9;
  width: 350px;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  padding-top: 30px;
  height: 130px;
  display: block;
  white-space: nowrap;

}
.spanbox1{
  position: inherit;
  left: 0;
  top: 0;
  width: 280px;
  z-index: 9;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tipbox{
  position: absolute;
  background: white;
  padding: 10px;
  position: absolute;
  top: 39px;
  left: 180px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.updataactive{
   border: 2px solid #07c160;
}
.centerbox{
  margin-left: 20px;
  width: 620px;
}
.centerinput{
  margin-bottom: 20px;
}
.ciclebox{
  padding: 15px 7px 5px 7px;
  margin: 0 7px;
  background-color: #fff;
  box-shadow: 0 1px 6px 0 #e4e8eb;
  border-radius: 25px;
  position: absolute;
  left: 430px;
  top: 50%;
  transform: translate(0, -50%);
}
.tiparrowbox{
  display: flex;
  flex-direction: column;
}
.tipicon{
  margin-bottom: 5px;
}
.tipicon{
  font-size:20px ;
  margin-bottom: 10px;
}
.chooseicon{
  width: 90px;
      height: 90px;
    box-sizing: border-box;
    border: 2px dashed #ebebeb;
    text-align: center;
    padding-top: 12px;
    position: relative;
    flex-shrink: 0;
}
.iconplus{
  color: #8f9091;
  font-size: 20px;
}
.btn-text{
  font-size: 12px;
      color: #7e8081;
      margin-top: 10px;
}
.setting-group__title{
  font-size: 16px;
    line-height: 20px;
    margin-bottom: 20px;
}
.backrbox{
width: auto;
    height: 100%;
  background-color: #e1e1e1;
    background-size: cover;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
.backrbox1{
    position: absolute;
    background-color: #e1e1e1;
        background-size: cover;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    top: 9px;
    right: 17px;
    width: 50px;
    height: 50px;
}
.select-cover__preview{
  position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
}
.abstractbox{
  width: 100%;
  display: flex;
}
.textfield{
  margin-left: 10px;
  height: 100%;
}
.cropper-content .cropper {
        width: auto;
        height: 600px;
}

audio {
  width: 100%;
  height: 50px;
  outline: none;
  filter: none;
}
.viewrw{
  margin-top: 20px;
}
.btne{
  margin-top: 20px;
}
.sdawr{
  font-size: 15px;
  margin-right: 10px;
}
.fansbox{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.chawepalite{
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.choosecover{
  display: flex;
  align-items: center;
}
 .editdraw /deep/ .el-drawer__body{
  height: 100%;
}
.bottom_box{
  height: 348px;
  width: 480px;
  overflow-y:scroll;
  margin-left: 20px;
  display: flex;
  flex-wrap: wrap;
}
.bottom_itembox{
  width: 220px;
  height: 90px;
  margin-right: 10px;
}
.bottom_qrcode{
  width: 616px;
  margin-bottom: 10px;
}
.bottom_Light{
  border: 2px solid #F56C6C;
}
.delter_icon{
  position: absolute;
  top: 9px;
  right: 10px;
}
.delter_icon i {
  font-size: 20px;
  cursor:pointer;
}
.link_url{
  margin: 15px 10px;
}
</style>
